import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import AddExamModal from "./AddExamModal";
import EditExamModal from "./EditExamModal";
import DeleteExamModal from "./DeleteExamModal";
// import ProfileCard from "../common/profileCard";
import InstructorSidebar from "../common/instructorSidebar";
import { deleteScheduleQuiz, getScheduleQuiz } from "utils/scheduleThunk";
import Breadcrumb from "core/common/Breadcrumb/breadcrumb";

const ScheduleExam = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("not-completed");
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [examsPerPage] = useState(5); // Number of exams per page
  const [editingExam, setEditingExam] = useState(null);
  const [deletingExam, setDeletingExam] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // Trigger to re-fetch exams
 const [noOfQuestions, setNoOfQuestions] = useState(0);
  // Fetch exams when activeTab or refreshTrigger changes
  useEffect(() => {
    const fetchExams = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await dispatch(getScheduleQuiz({ status: activeTab }));
        if (getScheduleQuiz.fulfilled.match(result)) {
          console.log("Fetched exams:", result.payload);
          setExams(result.payload.data || []);
          setCurrentPage(1); // Reset to first page on new fetch
        } else {
          throw new Error(result.payload?.message || "Failed to fetch exams");
        }
      } catch (err) {
        setError(err.message);
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchExams();
  }, [dispatch, activeTab, refreshTrigger]);

  const handleEditClick = (exam) => {
    setEditingExam(exam);
    const modal = document.getElementById("edit_exam");
    if (modal && window.bootstrap?.Modal) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modal) ||
        new window.bootstrap.Modal(modal);
      modalInstance.show();
    }
  };

  const handleDeleteClick = (exam) => {
    setDeletingExam(exam);
    const modal = document.getElementById("delete_exam");
    if (modal && window.bootstrap?.Modal) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modal) ||
        new window.bootstrap.Modal(modal);
      modalInstance.show();
    }
  };

  const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal && window.bootstrap?.Modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modal);
      modalInstance?.hide();
    }
  };

  const openAddModal = () => {
    const modal = document.getElementById("add_exam");
    if (modal && window.bootstrap?.Modal) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modal) ||
        new window.bootstrap.Modal(modal);
      modalInstance.show();
    }
  };

  // Callback to trigger re-fetching exams
  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };
  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = {
        scheduleExamId: deletingExam?._id
      };
      const result = await dispatch(deleteScheduleQuiz(payload));

      if (deleteScheduleQuiz.fulfilled.match(result)) {
        toast.success(result?.payload?.message || "Exam Deleted Successfully");

        // Close modal after successful deletion
        const modalEl = document.getElementById("delete_exam");
        if (modalEl && window.bootstrap?.Modal) {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
          modalInstance?.hide();
        }


        triggerRefresh(); // Refresh questions
      } else {
        throw new Error(result.payload?.message || "Failed to delete exam");
      }
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }
  // Pagination logic
  const filteredExams = exams.filter((exam) => exam.status === activeTab);
  const indexOfLastExam = currentPage * examsPerPage;
  const indexOfFirstExam = indexOfLastExam - examsPerPage;
  const currentExams = filteredExams.slice(indexOfFirstExam, indexOfLastExam);
  const totalPages = Math.ceil(filteredExams.length / examsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav aria-label="Exam pagination">
        <ul className="pagination justify-content-end mt-3">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              aria-label="Previous page"
            >
              <i className="fas fa-chevron-left"></i>

            </button>
          </li>
          {pageNumbers.map((number) => (
            <li
              key={number}
              className={`page-item ${currentPage === number ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => paginate(number)}
                aria-label={`Page ${number}`}
              >
                {number}
              </button>
            </li>
          ))}
          <li
            className={`page-item ${currentPage === totalPages ? "disabled" : ""
              }`}
          >
            <button
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              aria-label="Next page"
            >
              <i className="fas fa-chevron-right"></i>

            </button>
          </li>
        </ul>
      </nav>
    );
  };


  return (
    <>
      <Breadcrumb title="Schedule Exam" />
      <div className="content">
        <div className="container" >
          {/* <ProfileCard /> */}
          <div className="row">
            <InstructorSidebar />
            <div className="col-lg-9">
              <div className="card bg-light">
                <div className="card-body">
                  <div className="row align-items-center gy-3">
                    <div className="col-xl-8">
                      <h5 className="mb-2">Exam Schedule</h5>
                      <div className="exam-info d-flex align-items-center">
                        <p className="d-flex align-items-center fs-14 me-2 pe-2 border-end mb-0">
                          <i className="isax isax-calendar-1 text-primary-soft me-2"></i>
                          {exams.filter((e) => e.status === "not-completed").length} Upcoming
                        </p>
                        <p className="d-flex align-items-center fs-14 mb-0">
                          <i className="isax isax-tick-circle text-secondary-soft me-2"></i>
                          {exams.filter((e) => e.status === "completed").length} Completed
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-4 d-flex align-items-center justify-content-sm-end">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={openAddModal}
                        disabled={loading}
                        aria-label="Add new exam"
                      >
                        {loading ? "Loading..." : "Add Exam"}
                      </button>
                    </div>
                  </div>
                  {error && <div className="alert alert-danger mt-3">{error}</div>}
                </div>
              </div>

              <ul className="nav nav-tabs mt-3" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "not-completed" ? "active" : ""}`}
                    onClick={() => setActiveTab("not-completed")}
                    role="tab"
                    aria-selected={activeTab === "not-completed"}
                    aria-controls="upcoming-exams"
                    id="upcoming-tab"
                  >
                    Upcoming Exams
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
                    onClick={() => setActiveTab("completed")}
                    role="tab"
                    aria-selected={activeTab === "completed"}
                    aria-controls="completed-exams"
                    id="completed-tab"
                  >
                    Completed Exams
                  </button>
                </li>
              </ul>

              <div className="tab-content mt-3">
                <div
                  className={`tab-pane fade ${activeTab === "not-completed" ? "show active" : ""}`}
                  id="upcoming-exams"
                  role="tabpanel"
                  aria-labelledby="upcoming-tab"
                >
                  {loading ? (
                    <div>Loading exams...</div>
                  ) : currentExams.length > 0 ? (
                    currentExams.map((exam) => (
                      <div className="card mt-3" key={exam._id}>
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6>{exam.description}</h6>
                            <div>
                              <span
                                className={`badge text-white ${exam.status === "not-completed" ? "bg-primary" : "bg-success"
                                  }`}
                              >
                                {exam.status}
                              </span>{" "}
                              <button
                                className="d-inline-flex fs-14 me-2 action-icon"
                                onClick={() => handleEditClick(exam)}
                                aria-label={`Edit exam ${exam.description}`}
                                disabled={loading}
                              >
                                <i className="isax isax-edit-2"></i>
                              </button>
                              <button
                                className="d-inline-flex fs-14 action-icon"
                                onClick={() => handleDeleteClick(exam)}
                                aria-label={`Delete exam ${exam.description}`}
                                disabled={loading}
                              >
                                <i className="isax isax-trash"></i>
                              </button>
                            </div>
                          </div>
                         <div className="row">
                           <p className="mb-1 col-sm-6">
                            <strong>Exam Date:</strong> {exam.examDate}
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Exam Time:</strong> {exam.examTime}
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Exam Duration:</strong> {exam.duration} minutes
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Result Date:</strong> {exam.resultDate}
                          </p>
                           <p className="mb-0">
                            <strong>No. Of Questions:</strong> {exam.questions}
                          </p>
                         </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted">No {activeTab} exams found.</div>
                  )}
                  {renderPagination()}
                </div>
                <div
                  className={`tab-pane fade ${activeTab === "completed" ? "show active" : ""}`}
                  id="completed-exams"
                  role="tabpanel"
                  aria-labelledby="completed-tab"
                >
                  {loading ? (
                    <div>Loading exams...</div>
                  ) : currentExams.length > 0 ? (
                    currentExams.map((exam) => (
                      <div className="card mt-3" key={exam._id}>
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6>{exam.description}</h6>
                            <div>
                              <span
                                className={`badge text-white ${exam.status === "not-completed" ? "bg-primary" : "bg-success"
                                  }`}
                              >
                                {exam.status}
                              </span>{" "}
                              {/* <button
                                className="d-inline-flex fs-14 me-2 action-icon"
                                onClick={() => handleEditClick(exam)}
                                aria-label={`Edit exam ${exam.description}`}
                                disabled={loading}
                              >
                                <i className="isax isax-edit-2"></i>
                              </button> */}
                              <button
                                className="d-inline-flex fs-14 action-icon"
                                onClick={() => handleDeleteClick(exam)}
                                aria-label={`Delete exam ${exam.description}`}
                                disabled={loading}
                              >
                                <i className="isax isax-trash"></i>
                              </button>
                            </div>
                          </div>
                         <div className="row">
                           <p className="mb-1 col-sm-6">
                            <strong>Exam Date:</strong> {exam.examDate}
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Exam Time:</strong> {exam.examTime}
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Exam Duration:</strong> {exam.duration} minutes
                          </p>
                          <p className="mb-1 col-sm-6">
                            <strong>Result Date:</strong> {exam.resultDate}
                          </p>
                           <p className="mb-0">
                            <strong>No. Of Questions:</strong> {exam.questions}
                          </p>
                         </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted">No {activeTab} exams found.</div>
                  )}
                  {renderPagination()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddExamModal
        closeModal={() => closeModal("add_exam")}
        onExamChange={triggerRefresh}
      />
    <EditExamModal
        exam={editingExam}
        closeModal={() => closeModal("edit_exam")}
        onExamChange={triggerRefresh}
      /> 
      <DeleteExamModal
        exam={deletingExam}
        closeModal={() => closeModal("delete_exam")}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default ScheduleExam;